export function formatDate(timestamp: Date | number): string {
  if (!timestamp) {
    return '';
  }

  return new Date(timestamp).toISOString().slice(0, 10);
}

export function formatTime(timestamp: Date | number | string): string {
  if (!timestamp) {
    return '';
  }

  return new Date(timestamp).toISOString().slice(0, 19).replace('T', ' ');
}

export function getFirstMonthDay(initDate = new Date()): Date {
  const THREE_DAYS = 3 * 24 * 60 * 60 * 1000;
  const firstDay = new Date(initDate);

  firstDay.setDate(1);

  if (initDate.getTime() - firstDay.getTime() < THREE_DAYS) {
    firstDay.setMonth(firstDay.getMonth() - 1);
  }

  return firstDay;
}

export function getLastMonthDay(initDate = new Date()): Date {
  const lastDay = new Date(getFirstMonthDay(initDate));
  lastDay.setMonth(lastDay.getMonth() + 1);
  lastDay.setDate(0);
  return lastDay;
}
